import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class CatalogPrerequisiteService {

    constructor(private http:HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';

        let requestUrl = environment.apiUrl + 'catalog/prerequisite/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(prerequisite){
        let requestUrl = environment.apiUrl + 'catalog/prerequisite/store';
        return this.http.post(requestUrl, prerequisite).map( (res: any) => {
            return res;
        });
    }

    edit(prerequisite){
        let requestUrl = environment.apiUrl + 'catalog/prerequisite/update/' + prerequisite.id;
        return this.http.put(requestUrl, prerequisite).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'catalog/prerequisite/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id){
        let requestUrl = environment.apiUrl + 'catalog/prerequisite/delete/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/catalog.prerequisite.service.ts